import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';

@Component({
  selector: 'app-formly-autocomplete',
  templateUrl: './formly-autocomplete.component.html',
  styleUrls: ['./formly-autocomplete.component.scss']
})
export class FormlyAutocompleteComponent extends FieldType implements OnInit, AfterViewInit {
  filteredOptions: Observable<any[]>;
  @Input() language = 'English';
  languageOptions: any[];

  constructor() {
    super();
  }

  ngOnInit() {
    this.languageOptions = this.to.options as any[];

    this.filteredOptions = this.formControl.valueChanges.pipe(
      startWith('English'),
      tap(item => console.log(item)),
      map(value => (typeof value === 'string' ? value : value.label)),
      map(name => (name ? this._filter(name) : this.languageOptions.slice()))
    );
  }

  ngAfterViewInit(): void {}

  private _filter(value: any): string[] {
    const filterValue = value?.toLowerCase();

    return this.languageOptions.filter(option => {
      const haystack = option.label.toLowerCase().replace(/\W/g, '');
      const search = filterValue.toLowerCase().replace(/\W/g, '');
      console.log(haystack);
      console.log(search);

      function fuzzy_match(str, pattern) {
        pattern = pattern.split('').reduce((a, b) => {
          return a + '.*' + b;
        });
        return new RegExp(pattern).test(str);
      }

      return fuzzy_match(haystack, search);
    });
  }

  displayFn(item: any) {
    return item && item.label ? item.label : '';
  }

  languageChanged($event: any) {}
}
